/**
 * Created by Victor Rojo on 11/2/19.
 */
import { Component, OnInit, Input } from "@angular/core";
import { PetrolRankingService } from "./PetrolRanking.service";
import { FormGroup, FormControl } from "@angular/forms";
import { Station } from "./model/station";
import {
  BsDatepickerConfig,
  BsDatepickerViewMode
} from "ngx-bootstrap/datepicker";
import { I18NService } from "../shared/i18n/i18n.service";
import { IPlaceService } from "../iPlace/iPlace.service";

class Selectable {
  public id: string;
  public value: string;
}

@Component({
  selector: "petrol-ranking",
  templateUrl: "./PetrolRanking.component.html",
  styleUrls: ["./PetrolRanking.component.css"]
})
export class PetrolRankingComponent implements OnInit {
  title = "PetrolRanking Resultados";
  bsConfig: Partial<BsDatepickerConfig>;
  dropdownSettings: any = {};
  selectableStations: Selectable[] = [];
  selectedStations = [];
  selectableFuels: Selectable[];
  selectedFuel: String = "dieselA";
  selectedFuels: any;
  selectableOrderBys: Selectable[];
  orderBys: any;
  excelHeaders: any[];

  selectableRatios: Selectable[] = [
    { id: "1000", value: "1km" },
    { id: "3000", value: "3km" },
    { id: "5000", value: "5km" },
    { id: "10000", value: "10km" },
    { id: "15000", value: "15km" },
    { id: "30000", value: "30km" },
    { id: "50000", value: "50km" }
  ];
  ratios: any = [this.selectableRatios[2]];

  @Input("hideRatio") showRatio = true;

  latitude = 40;
  longitude = -3;

  stations: Station[];
  mainStation: Station;
  openedWindow = 0;

  maxDate = new Date();

  form = new FormGroup({
    selectedStations: new FormControl([this.selectedStations]),
    selectedFuels: new FormControl(this.selectedFuels),
    date: new FormControl(new Date()),
    ratios: new FormControl(this.ratios), // meters
    orderBys: new FormControl(this.orderBys)
  });

  constructor(
    private rankingService: PetrolRankingService,
    private i18nService: I18NService,
    private iPlaceService: IPlaceService
  ) {
    this.bsConfig = Object.assign(
      {},
      {
        containerClass: "theme-custom simple",
        showWeekNumbers: false,
        adaptivePosition: true,
        minMode: "day" as BsDatepickerViewMode
      }
    );

    this.dropdownSettings = {
      singleSelection: true,
      primaryKey: "id",
      labelKey: "value",
      searchPlaceholderText: i18nService.get("search"),
      enableSearchFilter: true,
      showCheckbox: false,
      classes: "simpledropdown",
      enableFilterSelectAll: false
    };

    this.selectableFuels = [
      { id: "dieselA", value: i18nService.get("dieselOil") },
      { id: "dieselAPremium", value: i18nService.get("dieselOilPremium") },
      { id: "petrol95", value: i18nService.get("petrol95") },
      { id: "petrol98", value: i18nService.get("petrol98") }
    ];
    this.selectedFuels = [
      { id: "dieselA", value: i18nService.get("dieselOil") }
    ];

    this.selectableOrderBys = [
      { id: "DISTANCE", value: this.i18nService.get("distance") },
      { id: "PRICE", value: this.i18nService.get("price") }
    ];
    this.orderBys = [this.selectableOrderBys[1]];

    this.excelHeaders = [
      { label: i18nService.get("fuelStation"), property: "label" },
      { label: i18nService.get("distanceMeters"), property: "distance" },
      { label: i18nService.get("address"), property: "address" },
      { label: i18nService.get("province"), property: "province" },
      { label: i18nService.get("dieselOil"), property: "dieselA" },
      {
        label: i18nService.get("dieselOilPremium"),
        property: "dieselAPremium"
      },
      { label: i18nService.get("petrol95"), property: "petrol95" },
      { label: i18nService.get("petrol98"), property: "petrol98" }
    ];
  }

  openWindow(petrolStationId: number) {
    if (this.isInfoWindowOpen(petrolStationId)) {
      this.openedWindow = 0;
    } else {
      this.openedWindow = petrolStationId;
    }
  }

  isInfoWindowOpen(petrolStationId: number) {
    return this.openedWindow === petrolStationId; // alternative: check if id is in array
  }

  roundDiference(price: number) {
    return Math.round(price * 1000) / 1000;
  }

  getPriceColor(station: Station, field: string) {
    if (!this.mainStation[field]) {
      return "#878382";
    }
    return this.mainStation[field] - station[field] == 0
      ? "#878382"
      : station[field] - this.mainStation[field] > 0
        ? "#878382"
        : "#de571d";
  }

  getIconColor(station: Station, field: string) {
    if (station.petrolStationId === this.mainStation.petrolStationId) {
      return "assets/images/station_prices/locationIcon/black.svg";
    }
    return this.mainStation[field] - station[field] === 0
      ? "assets/images/station_prices/locationIcon/grey.svg"
      : station[field] - this.mainStation[field] > 0
        ? "assets/images/station_prices/locationIcon/grey.svg"
        : "assets/images/station_prices/locationIcon/red.svg";
  }

  formatDate(date: Date) {
    let d = date,
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) {
      month = "0" + month;
    }
    if (day.length < 2) {
      day = "0" + day;
    }

    return [day, month, year].join("_");
  }

  parseDistance(meters: number) {
    if (meters > 9999) {
      return (meters / 1000).toFixed(1) + "km";
    } else if (meters > 1000) {
      return (meters / 1000).toFixed(2) + "km";
    } else {
      return meters + "m";
    }
  }

  getZoom() {
    let ratio = this.ratios[0].id;
    if (this.ratios[0].id > 30001) {
      return 9;
    } else if (ratio > 20001) {
      return 10;
    } else if (ratio >= 15000) {
      return 11;
    } else if (ratio > 3001) {
      return 12;
    } else {
      return 14;
    }
  }

  sortStations(stations: Station[], field: string) {
    function compare(a: Station, b: Station) {
      if (a[field] < b[field]) {
        return -1;
      }
      if (a[field] > b[field]) {
        return 1;
      }
      return 0;
    }
    stations.sort(compare);
  }

  loadData() {
    const formValues = this.form.value;
    let selectediPlaceId = this.selectedStations[0].id;
    this.selectedFuel = this.selectedFuels[0].id;
    let selectedFuel = this.selectedFuels[0].id;
    let selectedRatio = this.ratios[0].id;
    let selectedDate = formValues.date;
    selectedDate.setHours(0,0,0,0);
    this.rankingService
      .getNearStations({
        iPlaceId: selectediPlaceId,
        radius: selectedRatio,
        timemilis: selectedDate.getTime()
      })
      // .subscribe(response => {
      .then(response => {
        let stations = response as Station[];

        let filteredStations: Station[];

        filteredStations = stations.filter(station => {
          return station && station[selectedFuel];
        });

        if (
          formValues.orderBys[0] &&
          formValues.orderBys[0].id === "DISTANCE"
        ) {
          this.sortStations(filteredStations, "distance");
        } else {
          this.sortStations(filteredStations, selectedFuel);
        }

        filteredStations.forEach((station, index) => {
          station.index = index + 1;
        });

        this.stations = filteredStations;

        let mainStation = this.stations.filter(station => {
          return station.iPlaceId == selectediPlaceId;
        })[0];
        this.mainStation = mainStation;

        this.latitude = mainStation.latitude;
        this.longitude = mainStation.longitude;
      })
      .catch(err => {
        this.stations = [];
        console.error(err);
      });
  }

  exportData() {
    this.rankingService.exportAsExcelFile(
      this.excelHeaders,
      this.stations,
      this.mainStation.label + "_" + this.formatDate(this.form.value.date)
    );
  }

  ngOnInit() {
    this.iPlaceService
      .get()
      .then(iplaces => {
        this.selectableStations = iplaces.map(iplace => {
          return {
            id: iplace.id,
            value: iplace.iPlaceName
          };
        });
        this.selectedStations = [this.selectableStations[0]];
        this.loadData();
      })
      .catch(err => {
        console.error("NO IPLACES");
      });
  }

  itemDeSelect(item, property) {
    this[property] = [item];
  }
}
